import { combineEpics, ofType } from "redux-observable"
import { Subject } from "rxjs"
import { switchMap, takeUntil } from "rxjs/operators"

import { fetchContactsError, fetchContactsSuccess, types } from "../actions"
import { ContactListingsService } from "../services"

export const cancelToken$ = new Subject<boolean>()

export const cancelFetchContactsEpic = () => {
    if (!cancelToken$.closed) {
        cancelToken$.next(true)
    }
    cancelToken$.unsubscribe()
}

export const fetchContactsEpic = action$ =>
    action$.pipe(
        ofType(types.FETCH_CONTACTS),
        takeUntil(cancelToken$),
        switchMap(({ payload }) => {
            return ContactListingsService.GetContacts(payload)
                .then(response => {
                    return fetchContactsSuccess(response.data)
                })
                .catch(error => {
                    fetchContactsError(error)
                })
        })
    )

export const contactEpics = combineEpics(fetchContactsEpic)



// WEBPACK FOOTER //
// ./src/state/listing/contact/epics/contactEpics.ts